import { FC, useEffect, useState } from "react";
import { Row } from "../../containers";
import { IconAnimationProps } from "./types";
import { JustifyContent } from "../../containers/types";
import { Color } from "../../../types";
import { useThemeStore } from "../../../stores";

const IconAnimation: FC<IconAnimationProps> = ({
  Icon,
  onHoverColor,
  className,
  color,
  height,
  width,
  style,
  onClick = () => {},
}) => {
  const theme = useThemeStore((state) => state.theme);
  const [fill, setFill] = useState<Color>(color || theme.icon);

  useEffect(() => {
    if (color) {
      setFill(color);
    } else setFill(theme.icon);
  }, [theme, color]);

  return (
    <Row
      justifyContent={JustifyContent.Center}
      props={{
        onMouseEnter: () => {
          setFill(onHoverColor);
        },
        onMouseLeave: () => {
          setFill(color || theme.icon);
        },
        onClick,
      }}
      style={style}
    >
      <Icon
        className={`transition ${className}`}
        color={fill}
        height={height}
        width={width}
      />
    </Row>
  );
};

export default IconAnimation;
